module.exports = __webpack_public_path__ + "static/img/son8_active.a7bdc280.png";